// extracted by mini-css-extract-plugin
module.exports = {"mediaQueryColumn":"(min-width: 540px)"};